import React from "react";
import UploadPicture from "../index";
import { useMyExperienceDashboardDetails } from "../../../context/dashboard";
import useNavigateWrapper from "../../../../../shared/hooks/useNavigateWrapper";
import { getNameInitials } from "shared/utils";
import { useSearchParams } from "react-router-dom";
import QueryParamKey from "../../../../../shared/enums/QueryParamKey";
import { MyExpRoute } from "../../../routes/types";

export default function UploadProfilePictureHandler() {
  const { navigateToPreviousPath, navigate } = useNavigateWrapper();
  const [searchParams] = useSearchParams();
  const { data: dashboardData } = useMyExperienceDashboardDetails();

  const nameInitials = React.useMemo(
    () => getNameInitials(`${dashboardData.firstName} ${dashboardData.lastName}`) || "",
    [dashboardData.firstName, dashboardData.lastName]
  );

  const navigateToSocialMediaIfApplicable = React.useCallback((): boolean => {
    const socialMediaTemplateId = searchParams.get(QueryParamKey.SOCIAL_MEDIA_TEMPLATE_ID);
    if (socialMediaTemplateId) {
      navigate({
        pathname: `/${MyExpRoute.SOCIAL_MEDIA_SHARE.path}`,
        search: searchParams.toString()
      });
      return true;
    } else {
      return false;
    }
  }, [searchParams, navigate]);

  const closeHandler = React.useCallback(() => {
    const isRedirectedToSocialMedia = navigateToSocialMediaIfApplicable();
    if (!isRedirectedToSocialMedia) {
      navigateToPreviousPath();
    }
  }, [navigateToPreviousPath, navigateToSocialMediaIfApplicable]);

  const successHandler = React.useCallback(() => {
    closeHandler();
  }, [closeHandler]);

  return (
    <UploadPicture
      onClose={closeHandler}
      onSuccess={successHandler}
      regParticipantId={dashboardData?.registrationParticipantId}
      imageLocation={dashboardData?.profilePictureLocation}
      uiVersion={dashboardData?.uiVersion}
      nameInitials={nameInitials}
      isUploadByCameraEnabled={true}
    />
  );
}
